export default __webpack_public_path__ + "static/Montserrat-italic-6eed6b4cbb809c6efc7aa7ddad6dbe3e.woff2";